// ── Step 6 Candidate Preview — Pure DOM writes, no state or API ───────────

function createPreviewElement(tagName, className = '', text = null) {
  const element = document.createElement(tagName);
  if (className) element.className = className;
  if (text !== null) element.textContent = text;
  return element;
}

function createCandidateDiffCard(item = {}) {
  const card = createPreviewElement('div', 'revision-candidate-preview-card');
  card.append(createPreviewElement('strong', 'revision-candidate-preview-field', item.label ?? ''));

  const grid = createPreviewElement('div', 'revision-candidate-preview-grid');
  const before = createPreviewElement('div', 'revision-candidate-preview-column');
  before.append(
    createPreviewElement('div', 'revision-candidate-preview-label', '修改前'),
    createPreviewElement('div', 'revision-candidate-preview-text revision-candidate-preview-text--before', item.before ?? ''),
  );
  const after = createPreviewElement('div', 'revision-candidate-preview-column');
  after.append(
    createPreviewElement('div', 'revision-candidate-preview-label', '修改后'),
    createPreviewElement('div', 'revision-candidate-preview-text revision-candidate-preview-text--after', item.after ?? ''),
  );
  grid.append(before, after);
  card.append(grid);
  return card;
}

/**
 * Renders an untrusted candidate diff as text nodes only.
 * @returns {boolean} whether there is a candidate preview to show.
 */
export function renderCandidatePreviewInto(root, candidateRecord = null) {
  if (!root) return false;
  const items = Array.isArray(candidateRecord?.diffItems) ? candidateRecord.diffItems : [];
  if (!items.length) {
    root.replaceChildren();
    return false;
  }

  const version = Math.max(1, Number(candidateRecord?.version) || 1);
  const basedOnVersion = Math.max(0, Number(candidateRecord?.basedOnVersion) || 0);
  const versionCard = createPreviewElement('div', 'revision-candidate-preview-card');
  versionCard.append(
    createPreviewElement('strong', 'revision-candidate-preview-field', `候选稿 v${version}`),
    createPreviewElement(
      'div',
      'revision-candidate-preview-meta',
      basedOnVersion > 0 ? `基于候选稿 v${basedOnVersion} 继续优化` : '基于 Step03 原稿生成',
    ),
  );
  root.replaceChildren(versionCard, ...items.map(createCandidateDiffCard));
  return true;
}
